import React from "react";
import PropTypes from "prop-types";
import { ExternalLink } from "components/link";

const FooterLogo = ({ url, logoUrl, logoText }) => (
  <ExternalLink href={url}>
    <img src={logoUrl} alt={logoText} />
  </ExternalLink>
);

FooterLogo.propTypes = {
  /**
   * Url del enlace
   */
  url: PropTypes.string,
  /**
   * Url de la imagen del logo
   */
  logoUrl: PropTypes.string,
  /**
   * Texto del logo
   */
  logoText: PropTypes.string,
};

export default FooterLogo;
